export default __webpack_public_path__ + "static/default-starter-a3c2e708c0a6062d0ca133d9250148ab.png";